import Vue from 'vue'
import AdvCart from './AdvCart'
import Toasted from 'vue-toasted'
import store from '../../vue/store'
import CheckoutPage from './CheckoutPage'
import clientLocaleBundle from './locales'
import clientConfigurationBundle from './config'
import AdvProductCard from './AdvProductCard.vue'
import config from '../../vue/config/configPlugin'
import locale from '../../vue/locales/localePlugin'
import AdvCartGiftList from './AdvCartGiftList.vue'
import AdvButtonViewBuy from './AdvButtonViewBuy.vue'
import VueTinyLazyloadImg from 'vue-tiny-lazyload-img'
import AdvProductGallery from './AdvProductGallery.vue'
import AdvCartProductList from './AdvCartProductList.vue'
import InitialData from '../../vue/data-components/InitialData.vue'
import AdvMinicartGiftChoiceModal from './AdvMinicartGiftChoiceModal'
import AdvProductGalleryWithVideo from './AdvProductGalleryWithVideo.vue'
import LiveProductData from '../../vue/data-components/LiveProductData.vue'
import jqueryVueBridgePlugin from '../../vue/utilities/jqueryVueBridgePlugin'
import AdvHtmlPicture from '../../vue/components/AdvHtmlPicture'
import googleMapPartners from './googleMaps/components/googleMapPartners'
import VariationListingFilters from './variations/filters/Components/VariationListingFilters'

Vue.use(Toasted, { iconPack: 'fontawesome' })
Vue.use(VueTinyLazyloadImg)
Vue.use(config, { clientConfigurationBundle: clientConfigurationBundle })
Vue.use(locale, { clientLocaleBundle: clientLocaleBundle })
Vue.use(jqueryVueBridgePlugin)

window.Vue = new Vue({
  el: '#app',
  store,
  config,
  locale,
  jqueryVueBridgePlugin,
  components: {
    InitialData,
    LiveProductData,
    AdvProductCard,
    AdvButtonViewBuy,
    AdvCartProductList,
    AdvCartGiftList,
    AdvProductGallery,
    AdvCart,
    AdvProductGalleryWithVideo,
    CheckoutPage,
    AdvMinicartGiftChoiceModal,
    AdvHtmlPicture,
    VariationListingFilters,
    googleMapPartners
  },
  computed: {
    countCartProducts () {
      return store.getters.cartProductsCount
    },
    countCartProductPieces () {
      return store.getters.cartProductPiecesCount
    },
    cartHasProduct () {
      return !store.getters.cartEmpty
    },
    cartTotal () {
      return store.getters.cartProductsTotal.toFixed(2)
    },
    productCardModal () {
      return store.getters.productCardModal
    },
    cartProductWeightTotal () {
      return store.getters.cartProductWeightTotal
    },
    cartDefaultCouponCode () {
      return store.getters.getDefaultCouponCode
    },
    cartDefaultCouponDiscount () {
      return parseFloat(store.getters.getDefaultCouponDiscount).toFixed(2)
    },
    cartDefaultCouponName () {
      return store.getters.getDefaultCouponName
    },
    selectedCurrency () {
      return store.getters.getSelectedCurrency
    }
  },
  methods: {
    closeProductCardModal () {
      store.dispatch('closeProductCardModal')
    },
    checkConnectionStatus () {
      store.dispatch('setOnlineStatus', navigator.onLine)
    }
  },
  created () {
    this.checkConnectionStatus()
    window.addEventListener('offline', this.checkConnectionStatus)
    window.addEventListener('online', this.checkConnectionStatus)
  },
  destroyed () {
    window.removeEventListener('offline', this.checkConnectionStatus)
    window.removeEventListener('online', this.checkConnectionStatus)
  }
})
